import { render, staticRenderFns } from "./PopupAISafetyMeasures.vue?vue&type=template&id=0678356c&scoped=true"
import script from "./PopupAISafetyMeasures.vue?vue&type=script&lang=js"
export * from "./PopupAISafetyMeasures.vue?vue&type=script&lang=js"
import style0 from "./PopupAISafetyMeasures.vue?vue&type=style&index=0&id=0678356c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678356c",
  null
  
)

export default component.exports